import React from 'react';
import groupBy from 'lodash.groupby';
import { GridContainer, Column, Row, Typography } from '@vp/react-vp-ui-library';
import { getLocalizedText as t } from '@vp-dst/localization-util';
import isMobile from 'is-mobile';

import { Product } from '../services/products';
import { DownloadableTemplate, DownloadableTemplateType } from '../services/downloadableTemplates';
import downloadIcon from '../images/download_arrow.svg';
import { logAction } from '../utilities/logger';

export default function DownloadableTemplates({
  products,
}: {
  specsGroup: string;
  products: Product[];
}) {
  if (isMobile({ tablet: true })) {
    // tablet: true => return true for tablets
    // don't show downloadable templates on mobile; todo: is this the right thing to do? My phone can download stuff...
    return null;
  }

  // aggregate the downloadable templates into one big list
  const allDownloadableTemplates = products.reduce<DownloadableTemplate[]>(
    (downloadableTemplates, product) => {
      downloadableTemplates.push(...product.downloadableTempates);
      return downloadableTemplates;
    },
    [],
  );

  // group downloadable templates by their type
  const downloadableTemplatesByType = groupBy(allDownloadableTemplates, 'type');

  if (
    downloadableTemplatesByType[DownloadableTemplateType.PS] === undefined ||
    downloadableTemplatesByType[DownloadableTemplateType.AI] === undefined
  ) {
    return null;
  }

  const anyProduct = products[0];

  return (
    <GridContainer>
      <Row>
        <Column span={12}>
          <Typography purpose="heading" size={2} style={{ marginTop: 10, marginBottom: 45 }}>
            {t('download-design-templates')}
          </Typography>
          <Typography>
            {// todo: since we don't have good product names, I hacked the translation to remove the product name. I'm not omni-lingual, so I probably messed up.
            t('use-our-pre-sized-product-templates-hack').replace(
              '<product-name />',
              anyProduct.name,
            )}
          </Typography>
          <Row>
            <Column span={4}>
              <Row>
                <Column span={4}>
                  <Typography purpose="heading" size={5} strong={true}>
                    Photoshop
                  </Typography>
                </Column>
              </Row>
              <Row>
                <Column span={1}>
                  <div
                    style={{
                      border: '2px solid rgb(0, 97, 150)',
                      height: '45px',
                      width: '45px',
                      fontSize: '25px',
                      lineHeight: '45px',
                      textAlign: 'center',
                      color: 'rgb(0, 97, 150)',
                      borderRadius: '3px',
                    }}
                  >
                    Ps
                  </div>
                </Column>
                <Column span={3}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      height: 45,
                    }}
                  >
                    {downloadableTemplatesByType[DownloadableTemplateType.PS].map(
                      (downloadableTemplate, index) => (
                        <div key={`${DownloadableTemplateType.PS}-downloadable-template-${index}`}>
                          <a
                            href={downloadableTemplate.url}
                            style={{ fontWeight: 'normal', fontSize: '14px' }}
                            onClick={() => {
                              logAction('DownloadableTemplates', 'DownloadLink', 'Clicked', {
                                fileType: downloadableTemplate.type,
                              });
                            }}
                          >
                            {' '}
                            {downloadableTemplate.label}
                          </a>
                          <img
                            style={{ paddingLeft: '7px', height: '10' }}
                            src={downloadIcon}
                            alt="Download"
                          />
                        </div>
                      ),
                    )}
                  </div>
                </Column>
              </Row>
            </Column>

            <Column span={4}>
              <Row>
                <Column span={4}>
                  <Typography purpose="heading" size={5} strong={true}>
                    Illustrator
                  </Typography>
                </Column>
              </Row>
              <Row>
                <Column span={1}>
                  <div
                    style={{
                      border: '2px solid rgb(255, 130, 1)',
                      height: '45px',
                      width: '45px',
                      fontSize: '25px',
                      lineHeight: '45px',
                      textAlign: 'center',
                      color: 'rgb(255, 130, 1)',
                      borderRadius: '3px',
                    }}
                  >
                    Ai
                  </div>
                </Column>
                <Column span={3}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      height: 45,
                    }}
                  >
                    {downloadableTemplatesByType[DownloadableTemplateType.AI].map(
                      (downloadableTemplate, index) => (
                        <div key={`${DownloadableTemplateType.AI}-downloadable-template-${index}`}>
                          <a
                            href={downloadableTemplate.url}
                            style={{ fontWeight: 'normal', fontSize: '14px' }}
                          >
                            {' '}
                            {downloadableTemplate.label}
                          </a>
                          <img
                            style={{ paddingLeft: '7px', height: '10' }}
                            src={downloadIcon}
                            alt="Download"
                          />
                        </div>
                      ),
                    )}
                  </div>
                </Column>
              </Row>
            </Column>
          </Row>
        </Column>
      </Row>
    </GridContainer>
  );
}
